// extracted by mini-css-extract-plugin
export default {"pdfContainer":"ObavijestDetail_pdfContainer__Q9lip","mobile__size":"ObavijestDetail_mobile__size__2ngVC"};